export default {
      id: "crossdevice_web-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#crossdevice_web",
      toString: function () {
        return this.url;
      }
    }